import React from 'react';
import { 
  Box, 
  Typography, 
  Avatar, 
  Button 
} from '@mui/material';
import NoteIcon from '@mui/icons-material/Note';
import AddIcon from '@mui/icons-material/Add';

const EmptyNotesCard = ({ 
  onAddNote, 
  title = "No Notes Available", 
  description = "No notes have been added yet. Add your first note to keep track of important information.",
  buttonText = "Add Note",
  showButton = true,
  compact = false 
}) => {
  return (
    <Box sx={{ 
      p: compact ? 2.5 : 4, 
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: compact ? 120 : 200
    }}>
      <Avatar 
        sx={{ 
          bgcolor: 'rgba(255, 179, 0, 0.1)', 
          color: '#FFB300', 
          width: compact ? 40 : 56, 
          height: compact ? 40 : 56,
          margin: '0 auto',
          mb: compact ? 1.5 : 2,
          boxShadow: '0 4px 12px rgba(255, 179, 0, 0.2)'
        }}
      >
        <NoteIcon sx={{ fontSize: compact ? 20 : 28 }} />
      </Avatar>
      
      <Typography 
        variant={compact ? "subtitle1" : "h6"} 
        color="text.primary" 
        sx={{ 
          fontWeight: 600, 
          mb: compact ? 0.5 : 1,
          fontSize: compact ? '0.875rem' : '1.125rem'
        }}
      >
        {title}
      </Typography>
      
      <Typography 
        variant="body2" 
        color="text.secondary" 
        sx={{ 
          lineHeight: 1.6, 
          mb: compact ? 1.5 : 2,
          fontSize: compact ? '0.813rem' : '0.875rem',
          maxWidth: 300
        }}
      >
        {description}
      </Typography>
      
      {showButton && onAddNote && (
        <Button 
          startIcon={<AddIcon sx={{ fontSize: compact ? '0.875rem' : '1rem' }} />}
          variant="contained"
          size="small"
          onClick={onAddNote}
          sx={{ 
            textTransform: 'none',
            fontSize: compact ? '0.813rem' : '0.875rem',
            fontWeight: 500,
            bgcolor: '#FFB300',
            borderRadius: '6px',
            boxShadow: '0 2px 4px rgba(255, 179, 0, 0.2)',
            '&:hover': {
              bgcolor: '#FFA000',
              boxShadow: '0 4px 8px rgba(255, 179, 0, 0.3)'
            }
          }}
        >
          {buttonText}
        </Button>
      )}
    </Box>
  );
};

export default EmptyNotesCard; 